import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router";
import { DropdownService } from '../../services/dropdown.service'
import { MessageService } from 'primeng/components/common/messageservice';
import { LeadService } from '../../services/lead.service';
import { Globals } from '../../services/globals.service';
import { ILead } from '../../interfaces/lead'

@Component({
  selector: 'app-add-edit-lead',
  templateUrl: './add-edit-lead.component.html',
  styleUrls: ['./add-edit-lead.component.css']
})
export class AddEditLeadComponent implements OnInit {
  tempLead: ILead = <ILead>{};
  isFormReady: boolean = false;
  dbLead: any = [];
  pLid: number;
  title: string;
  form: FormGroup;
  submitted : boolean = false;
  data: any;
  ddStates: IddStates[];
  ddIndustries: IIndustry[];
  ddTimings: ITiming[];
  ddStatus: IStatus[];
  ddLeadType: ILeadType[];
  ddEmployees: IEmployee[];
  mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  phoneExtPattern = /^[1]?[-\.\s]?(\(\d{3}\)|\d{3}){1}[-\.\s]?\d{3}[-\.\s]?\d{4}(\s+|\s*[-\.x]{1}\d{1,6})?$/;
  phonePattern = /^\(?(\d{3})\)?[-\. ]?(\d{3})[-\. ]?(\d{4})$/;
  urlPattern = /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/;
  numbersPattern = /^[0-9]*$/;
  notSelect = /^((?!Select...).)*$/;
  zipUsPattern = '^[0-9]{5}(?:-[0-9]{4})?$';
  zipUsCnPattern = /^([0-9]{5}(?:-[0-9]{4})?|[A-CEGHJ-NPRSTVXY]\d[A-CEGHJ-NPRSTV-Z] ?\d[A-CEGHJ-NPRSTV-Z]\d)$/;

  constructor(private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private messageService: MessageService,
    private leadService: LeadService,
    private globals: Globals,
    private dropdownService: DropdownService,
  ) {
    this.pLid = Number(this.route.snapshot.paramMap.get('lid'));
    if (this.pLid === 0) {
      this.title = "Add a new lead";
      this.createForm();
      this.isFormReady = true;
    } else {
      this.title = "Edit a new lead";
      this.leadService.getLead(this.pLid)
        .subscribe(
        data => {
          this.dbLead = data;
          this.createFormForEdit();
          this.isFormReady = true;
          console.log(data);
        },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error getting lead', detail: err.error });
            console.log(err);
          }
        );
    }

    dropdownService.getDDStates()
      .subscribe(
        data => this.ddStates = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting states for dropdown list', detail: err.message });
          console.log(err);
        }
      );

    dropdownService.getDDIndustries()
      .subscribe(
        data => this.ddIndustries = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting industries for dropdown list', detail: err.message });
          console.log(err);
        }
      );

    dropdownService.getDDTimings()
      .subscribe(
        data => this.ddTimings = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting timings for dropdown list', detail: err.message });
          console.log(err);
        }
      );

    dropdownService.getDDStatus()
      .subscribe(
        data => this.ddStatus = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting status for dropdown list', detail: err.message });
          console.log(err);
        }
      );

    dropdownService.getDDLeadType()
      .subscribe(
        data => this.ddLeadType = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting lead types for dropdown list', detail: err.message });
          console.log(err);
        }
      );

    dropdownService.getDDEmployees()
      .subscribe(
        data => this.ddEmployees = data,
        err => {
          this.messageService.add({ severity: 'error', summary: 'Error getting employees for dropdown list', detail: err.message });
          console.log(err);
        }
      );

  }

  createForm() {
    this.form = this.fb.group({
      OriginationDate: ['', Validators.required],
      FollowupDate: [''],
      Company: [''],
      Division: [''],
      Contact: ['', Validators.required],
      Title: ['', Validators.required],
      Address1: [''],
      Address2: [''],
      Suite: [''],
      City: [''],
      State: [''],
      Zip: ['', Validators.pattern(this.zipUsCnPattern)],
      Email: ['', [Validators.email]],
      Phone: ['', [Validators.required]],
      Fax: [''],
      Mobile: [''],
      Web: ['', [Validators.pattern(this.urlPattern)]],
      Type: ['Select...', Validators.pattern(this.notSelect)],
      Status: [''],
      Source: ['', Validators.required],
      Industry: ['Select...', Validators.pattern(this.notSelect)],
      Parent: [''],
      Application: [''],
      Timing: [''],
      Product: ['', Validators.required],
      NAICS: ['', [Validators.required, Validators.pattern(this.numbersPattern)]],
      SIC: ['', [Validators.required, Validators.pattern(this.numbersPattern)]],
      Employees: [''],
    }, {
    });
  }
  createFormForEdit() {
    this.form = this.fb.group({
      OriginationDate: [new Date(this.dbLead.std2.stdv.std.uwhen), Validators.required],
      FollowupDate: [new Date(this.dbLead.std2.stdv.std.followup)],
      Company: [this.dbLead.std2.stdv.std.company],
      Division: [this.dbLead.std2.stdv.std.division],
      Contact: [this.dbLead.std2.stdv.std.contact, Validators.required],
      Title: [this.dbLead.std2.stdv.std.title, Validators.required],
      Address1: [this.dbLead.std2.stdv.std.address1],
      Address2: [this.dbLead.std2.stdv.std.address2],
      Suite: [this.dbLead.std2.stdv.std.suite],
      City: [this.dbLead.std2.stdv.std.city],
      State: [this.dbLead.std2.stdv.std.state],
      Zip: [this.dbLead.std2.stdv.std.zip, Validators.pattern(this.zipUsCnPattern)],
      Email: [this.dbLead.std2.stdv.std.email, [Validators.email]],
      Phone: [this.dbLead.std2.stdv.std.phone, [Validators.required]],
      Fax: [this.dbLead.std2.stdv.std.fax],
      Mobile: [this.dbLead.std2.stdv.std.mobile],
      Web: [this.dbLead.std2.stdv.std.web, [Validators.pattern(this.urlPattern)]],
      Type: [this.dbLead.std2.stdv.std.uldstat, Validators.pattern(this.notSelect)],
      Status: [this.dbLead.std2.stdv.std.status],
      Source: [this.dbLead.std2.source, Validators.required],
      Industry: [this.dbLead.std2.stdv.std.uindustry, Validators.pattern(this.notSelect)],
      Parent: [this.dbLead.std2.stdv.std.uparent],
      Application: [this.dbLead.std2.stdv.std.ucurrentap],
      Timing: [this.dbLead.std2.stdv.std.ubuywhen],
      Product: [this.dbLead.std2.stdv.std.uproduct, Validators.required],
      NAICS: [this.dbLead.std2.stdv.std.unaics, [Validators.required, Validators.pattern(this.numbersPattern)]],
      SIC: [this.dbLead.std2.stdv.std.usic, [Validators.required, Validators.pattern(this.numbersPattern)]],
      Employees: [this.dbLead.std2.stdv.std.uemployee],
    }, {
    });
  }

  ngOnInit() {
    //this.createFormForEdit();
  }

  get ff() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.form.invalid) {
        alert("There are errors on the form");
        return;
    }

    // build a temporary lead object from form values
    this.tempLead.lid = this.pLid;       // signal an add, not an update with a 0
    this.tempLead.clientCode = this.globals.cc;
    this.tempLead.originationDate = this.form.value.OriginationDate;
    this.tempLead.followupDate = this.form.value.FollowupDate;
    this.tempLead.modifiedDate = new Date();
    this.tempLead.company = this.form.value.Company;
    this.tempLead.division = this.form.value.Division;
    this.tempLead.contact = this.form.value.Contact;
    this.tempLead.title = this.form.value.Title;
    this.tempLead.address1 = this.form.value.Address1;
    this.tempLead.address2 = this.form.value.Address2;
    this.tempLead.suite = this.form.value.Suite;
    this.tempLead.city = this.form.value.City;
    this.tempLead.state = this.form.value.State;
    this.tempLead.zip = this.form.value.Zip;
    this.tempLead.email = this.form.value.Email;
    this.tempLead.phone = this.form.value.Phone;
    this.tempLead.fax = this.form.value.Fax;
    this.tempLead.mobile = this.form.value.Mobile;
    this.tempLead.web = this.form.value.Web;
    this.tempLead.type = this.form.value.Type;
    this.tempLead.status = this.form.value.Status;
    this.tempLead.industry = this.form.value.Industry;
    this.tempLead.parent = this.form.value.Parent;
    this.tempLead.application = this.form.value.Application;
    this.tempLead.timing = this.form.value.Timing;
    this.tempLead.product = this.form.value.Product;
    this.tempLead.naics = this.form.value.NAICS;
    this.tempLead.sic = this.form.value.SIC;
    this.tempLead.employees = this.form.value.Employees;
    this.tempLead.source = this.form.value.Source;

    console.log(this.tempLead);
    if (this.pLid === 0) {
      this.leadService.postLead(this.tempLead)
        .subscribe(
          data => {
            this.messageService.add({
              severity: 'info',
              summary: 'Lead Created with a Lead ID of: ',
              detail: data.lid.toString()
            });
            this.router.navigate(["/lead-grid"]);
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error saving lead', detail: err.message });
            console.error(err);
            this.form.setErrors({
              "post lead": err.error
            });
          });
    } else {
      this.leadService.putLead(this.tempLead)
        .subscribe(
          data => {
            this.messageService.add({
              severity: 'info',
              summary: 'Lead Updated with a Lead ID of: ',
              detail: data.lid.toString()
            });
            this.router.navigate(["/lead-grid"]);
          },
          err => {
            this.messageService.add({ severity: 'error', summary: 'Error updating lead', detail: err.message });
            console.error(err);
            this.form.setErrors({
              "put lead": err.error
            });
          });
    }
  }

    onBack() {
    this.router.navigate(["/lead-grid"]);
  }

  // retrieve a FormControl
  getFormControl(name: string) {
    return this.form.get(name);
  }

  // returns TRUE if the FormControl is valid
  isValid(name: string) {
    var e = this.getFormControl(name);
    return e && e.valid;
  }

  // returns TRUE if the FormControl has been changed
  isChanged(name: string) {
    var e = this.getFormControl(name);
    return e && (e.dirty || e.touched);
  }

  // returns TRUE if the FormControl is invalid after user changes
  hasError(name: string) {
    var e = this.getFormControl(name);
    return e && (e.dirty || e.touched) && !e.valid;
  }

}
